module.exports = __webpack_public_path__ + "img/search_univ.2ec65e0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/search_univ.jpeg
// module id = 1214
// module chunks = 1